<template lang="pug">
  el-form(ref="form" @submit.native.prevent='' label-position="top" :rules="rules" :model="program")

    el-row(:gutter="40")
      el-col(:lg="17")
        el-form-item(prop="title")
          Label(slot="label" label="Title")
            | Insert programme title here, this will be seen by the colleagues who have been assigned to this programme.
          el-input(v-model.trim="program.title" size='large')

        el-form-item(prop="description")
          Label(slot="label" label="Description")
            | Add a helpful description that briefly explains the content within this programme.
          el-input(type='textarea' :autosize="{ minRows: 3, maxRows: 10}" v-model.trim="program.description")

        el-form-item(prop="image")
          Label(slot="label" label="Cover image")
            | Add a cover image which illustrates the content within this programme.
          ImageField(v-model='program.coverImagePath' :initial-url='program.coverImageUrl' bucket-key='programs')

        h4.courses-title Courses in this program
          fa-icon.tooltip-icon(icon="info-circle" size="xs" v-tooltip.top="{ content:'Select the courses you want to add to this programme', classes:'ethos-tooltip'}")

        .courses
          .course-list
            .program-course-item(v-for="(programCourse, pcIndex) in normalisedProgramCourses" :class="{deleted: programCourse._deleted}")
              .program-course-item-main
                .program-course-num {{ pcIndex + 1 }}
                .program-course-bar
                  router-link(:to='{name: "itrain:courseEdit", params: { courseId: programCourse.course.id }}' target="_blank")
                    | {{ programCourse.course.title }}

                  el-dropdown.program-course-menu(trigger='click' @command="handleCourseMenuAction")
                    span.menu-trigger
                      icon(name="ellipsis-v" scale="1.2" color='#999')
                    el-dropdown-menu(slot='dropdown')
                      el-dropdown-item(command="moveUp") Move up
                      el-dropdown-item(command="moveDown") Move down
                      el-dropdown-item(:command="{action: 'delete', index: pcIndex }" divided) Remove

              .program-course-deps(v-if='programCourse.dependencies.length')
                .program-course-dep-title
                  | Depends on the following course(s) being succesfully passed
                  el-tooltip(effect="light" placement="top")
                    template(slot="content")
                      | This course is unlocked only
                      br
                      | once all these courses are passed
                    icon(name='question-circle' color='#D3DCE6' :scale='1' :style="{marginLeft: 10}")

                .program-course-dep-item(v-for='(dep, depIndex) in programCourse.dependencies' :key='depIndex')
                  .program-course-dep-icon ↳
                  .program-course-dep-item-main(:class="{deleted: dep._deleted}") {{ dep.dependsOnCourse.title }}
                  el-dropdown.program-course-menu(v-if="!dep._deleted" trigger='click' @command="handleCourseDepMenuAction")
                    span.menu-trigger
                      icon(name="ellipsis-v" scale="1.2" color='#999')
                    el-dropdown-menu(slot='dropdown')
                      el-dropdown-item(:command="{action: 'delete', pcIndex, depIndex }") Remove

          .separator

          .add-course
            h4.add-course-header Add a Course to this program

            .program-course-form
              el-form-item(label='Course')
                el-select(v-model='newProgramCourse.course' placeholder='Select course' filterable)
                  el-option(v-for='courseOpt in courseOptions'
                    :key='courseOpt.course.id'
                    :label='courseOpt.course.title'
                    :disabled='courseOpt.disabled'
                    :value='courseOpt.course.id')
                      | {{ courseOpt.course.title }}
                      el-tag(v-if="courseOpt.disabled" type="gray" :style="{marginLeft: '10px'}") Already included


              el-form-item(label='')
                Label(slot="label" label="Depends on the following course(s) being succesfully passed")
                  | Dependencies are ways to set pre-requisites for other courses to be completed before a new course can be taken.
                .added-dependencies
                  .dependency(v-for='(dep, index) in normalisedNewProgramCourseDeps' :key='index')
                    .dependency-title • {{ dep.dependsOnCourse.title }}
                    .dependency-actions
                      .dependency-action
                        el-button(type="text" @click='removeCourseDependency(index)') Remove

                el-row(type='flex' :gutter="10")
                  el-col
                    el-select(v-model='newDependency.dependsOnCourse' placeholder='Select parent course' filterable clearable)
                      el-option(v-for='courseOpt in courseDependencyOptions'
                                :key='courseOpt.course.id'
                                :label='courseOpt.course.title'
                                :value='courseOpt.course.id'
                                :disabled='courseOpt.disabled'
                      )
                  el-col
                    el-button(@click="addDependency" :disabled='!newProgramCourse.course || !newDependency.dependsOnCourse') Add dependency

                el-row(:style="{margin: '10px 0 0 0'}")
                  el-button(@click="addProgramCourse" :disabled='!newProgramCourse.course') Add
                  fa-icon.tooltip-icon-p(icon="info-circle" size="xs" :style="{left: '69px',top: '25px'}" v-tooltip.top="{ content:'Click ADD to add this course to the programme.', classes:'ethos-tooltip'}")

        .notifications
          h4.courses-title
            | Notification Settings
            fa-icon.tooltip-icon-p(icon="info-circle" size="xs" :style="{left: '176px',top: '3px'}" v-tooltip.top="{ content:'Toggle on/off and tailor notifications.', classes:'ethos-tooltip'}")
          el-form
            el-row(:gutter='10')
              el-col.panel(:sm='12')
                h3 By email
                .panel-box
                  el-row(:gutter='10')
                    el-col(:sm='4')
                      el-form-item
                        el-switch(v-model="program.notifyOptions.onUserAssigned.sendEmail" on-color="#13ce66" off-color="#ff4949" on-text="" off-text="")
                    el-col(:sm='20')
                      el-form-item
                        | When user is assigned to the program
                        .message-box
                          .message-header Hello [name],
                          el-input(type="textarea" :autosize="{ minRows: 4, maxRows: 10}" placeholder="You email message here..." v-model="program.notifyOptions.onUserAssigned.emailMessage")

                  el-row(:gutter='10')
                    el-col(:sm='4')
                      el-form-item
                        el-switch(v-model="program.notifyOptions.onCourseAdded.sendEmail" on-color="#13ce66" off-color="#ff4949" on-text="" off-text="")
                    el-col(:sm='20')
                      el-form-item
                        | When a new course has been added
                        .message-box
                          .message-header Hello [name],
                          el-input(type="textarea" :autosize="{ minRows: 4, maxRows: 10}" placeholder="You email message here..." v-model="program.notifyOptions.onCourseAdded.emailMessage")

              el-col.panel(:sm='12')
                h3 By SMS
                .panel-box
                  el-row(:gutter='10')
                    el-col(:sm='4')
                      el-form-item
                        el-switch(v-model="program.notifyOptions.onUserAssigned.sendSms" on-color="#13ce66" off-color="#ff4949" on-text="" off-text="")
                    el-col(:sm='20')
                      el-form-item
                        | When user is assigned to the program
                        .message-box
                          .message-header Hello [name],
                          el-input(type="textarea" :autosize="{ minRows: 4, maxRows: 10}" placeholder="You sms message here..." v-model="program.notifyOptions.onUserAssigned.smsMessage")

                  el-row(:gutter='10')
                    el-col(:sm='4')
                      el-form-item
                        el-switch(v-model="program.notifyOptions.onCourseAdded.sendSms" on-color="#13ce66" off-color="#ff4949" on-text="" off-text="")
                    el-col(:sm='20')
                      el-form-item
                        | When a new course has been added
                        .message-box
                          .message-header Hello [name],
                          el-input(type="textarea" :autosize="{ minRows: 4, maxRows: 10}" placeholder="You sms message here..." v-model="program.notifyOptions.onCourseAdded.smsMessage")


      el-col(:lg="7")
        FormSidebar
          template(slot="content")
            h5.side-title Who would you like to complete this program?
            assignee-picker(:assignees.sync='assignees')

          template(slot="actions")
            el-button(v-if='!published' type='primary' native-type='submit' size='large' @click="onSave") Save as Draft
            el-button(v-if='published' type='primary' native-type='submit' size='large' @click="onSave") Save

            el-button(v-if='!published' type='success' native-type='submit' size='large' @click="onPublish") Publish
            el-button(v-if='isUpdating' type='text' @click="onDelete") Delete

</template>

<script>
import _ from "lodash";
import AssigneePicker from "@/brapp/components/shared/AssigneePicker";
import FormSidebar from "@/shared/components/layout/FormSidebar";
import ImageField from "@/shared/components/ImageField";
import LabelWithHelp from "@/itrain/components/shared/LabelWithHelp";

const EMPTY_PROGRAM_COURSE = { course: null, dependencies: [] };
const EMPTY_PROGRAM_DEPENDENCY = { dependsOnCourse: null };

export default {
  components: { AssigneePicker, FormSidebar, ImageField, Label: LabelWithHelp },
  model: {
    prop: "program",
    event: "change"
  },
  props: {
    create: {
      type: Boolean,
      default: true
    },
    showDelete: {
      type: Boolean,
      default: true
    },
    program: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      formSubmitted: false,
      courseList: [],
      newProgramCourse: _.cloneDeep(EMPTY_PROGRAM_COURSE),
      newDependency: _.cloneDeep(EMPTY_PROGRAM_DEPENDENCY),
      rules: {
        title: [{ required: true, message: "Required field", trigger: "blur" }]
      }
    };
  },
  computed: {
    isUpdating() {
      return this.program.id;
    },
    published: {
      get() {
        return this.program.status === "published";
      },
      set(val) {
        this.program.status = val ? "published" : "draft";
      }
    },
    assignees: {
      get() {
        return {
          users: this.program.assignees.filter(a => a.user).map(a => a.user),
          appLicenseGroups: this.program.assignees
            .filter(a => a.appLicenseGroup)
            .map(a => a.appLicenseGroup)
        };
      },
      set(val) {
        this.program.assignees = val.users
          .map(u => ({ user: u }))
          .concat(val.appLicenseGroups.map(g => ({ appLicenseGroup: g })));
      }
    },
    courseOptions() {
      return this.courseList.map(course => ({
        course,
        disabled:
          this.newProgramCourse.course === course.id ||
          this.program.programCourses.findIndex(
            pc =>
              !pc._deleted &&
              (pc.course === course.id || pc.course.id === course.id)
          ) > -1
      }));
    },
    courseDependencyOptions() {
      return this.courseList.map(course => ({
        course,
        disabled:
          this.newProgramCourse.course === course.id ||
          this.newProgramCourse.dependencies.findIndex(
            pc => pc.dependsOnCourse === course.id
          ) > -1
      }));
    },
    normalisedProgramCourses() {
      return this.program.programCourses.map(progCourse => ({
        ...progCourse,
        course: this.normaliseCourseOption(progCourse.course),
        dependencies: progCourse.dependencies.map(dep => ({
          ...dep,
          dependsOnCourse: this.normaliseCourseOption(dep.dependsOnCourse)
        }))
      }));
    },
    normalisedNewProgramCourseDeps() {
      return this.newProgramCourse.dependencies.map(dep => ({
        ...dep,
        dependsOnCourse: this.normaliseCourseOption(dep.dependsOnCourse)
      }));
    }
  },
  methods: {
    handleCourseMenuAction({ action, index }) {
      switch (action) {
        case "delete":
          this.$set(this.program.programCourses[index], "_deleted", true);
          return;
      }
    },
    handleCourseDepMenuAction({ action, pcIndex, depIndex }) {
      switch (action) {
        case "delete":
          this.$set(
            this.program.programCourses[pcIndex]["dependencies"][depIndex],
            "_deleted",
            true
          );
          return;
      }
    },
    onSave() {
      this.formSubmitted = true;
      this.$refs.form.validate(valid => {
        this.$emit("save", { valid });
      });
    },
    onPublish() {
      this.program.status = "published";
      this.onSave();
    },
    onDelete() {
      this.$emit("delete");
    },
    resetNewProgramCourse() {
      this.newProgramCourse = _.cloneDeep(EMPTY_PROGRAM_COURSE);
    },
    addProgramCourse() {
      this.program.programCourses.push(this.newProgramCourse);
      this.resetNewProgramCourse();
    },
    addDependency() {
      this.newProgramCourse.dependencies.push(this.newDependency);
      this.newDependency = _.cloneDeep(EMPTY_PROGRAM_DEPENDENCY);
    },
    normaliseCourseOption(courseIdOrObj) {
      return _.isPlainObject(courseIdOrObj)
        ? courseIdOrObj
        : this.courseList.find(c => c.id === courseIdOrObj);
    },
    removeCourseDependency(index) {
      this.newProgramCourse.dependencies.splice(index, 1);
    }
  },
  async created() {
    const data = await this.$store.dispatch("courses/fetchCourses", {
      company: this.$store.getters["auth/activeCompany"].id
    });
    this.courseList = data;
  }
};
</script>

<style scoped lang="scss">
.courses {
  background: #fff;
  border: 1px solid #ddd;
  padding: 15px;
  border-radius: 2px;
}

.program-course-form {
  background: #eee;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 2px;
}

.course-list {
  margin-top: 10px;
}

.program-course-deps {
  margin-top: 10px;
  margin-bottom: 10px;
}

.program-course-item {
  margin-bottom: 10px;
}

.deleted {
  opacity: 0.3;
  border: 1px dashed darkred !important;
}

.program-course-item-main {
  display: flex;
  align-items: center;
}

.program-course-num {
  flex: 0 0 40px;
  background: #fff;
  padding: 10px;
  border: 1px solid #ddd;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  border-radius: 2px;
}

.program-course-bar {
  background: #fff;
  padding: 10px;
  border: 1px solid #ddd;
  flex: 1;
  border-radius: 2px;
  position: relative;
}

.program-course-menu {
  position: absolute;
  top: 5px;
  right: 5px;
}

.add-course-header {
  margin: 20px 0 20px 0;
}

.program-course-dep-title {
  font-size: 13px;
  font-weight: bold;
  margin-left: 75px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}

.program-course-dep-item {
  display: flex;
  align-items: center;
  position: relative;
}

.program-course-dep-item-main {
  background: #eee;
  padding: 10px;
  display: flex;
  border: 1px solid #ddd;
  align-items: center;
  margin-bottom: 10px;
  border-radius: 2px;
  flex: 1;
}

.program-course-dep-icon {
  margin-left: 45px;
  margin-right: 10px;
  font-size: 22px;
  color: #666;
}

.courses-title {
  margin-bottom: 10px;
  font-family: gilroyextrabold;
  text-transform: uppercase;
  font-weight: normal;
  letter-spacing: 0.05em;
  font-size: 14px;
  color: #2c3e50;
}

.separator {
  border-top: 1px solid #ddd;
  margin: 25px -15px 15px -15px;
}

.menu-trigger {
  cursor: pointer;
  padding: 5px;
  width: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid transparent;
  border-radius: 3px;
  &:hover {
    border-color: #ddd;
  }
}

.message-header {
  background: #f4f5f7;
  border: 1px solid #ccc;
  border-bottom: 0;
  padding: 0 10px;
  border-radius: 3px 3px 0 0;
}

.notifications {
  margin-top: 30px;
  position: relative;
  h2 {
    margin-bottom: 20px;
  }
}

.panel {
  h3 {
    margin-bottom: 10px;
    font-size: 18px;
  }
}

.panel-box {
  border: 1px solid #ddd;
  padding: 20px;
  background: white;
}

.side-title {
  margin-bottom: 20px;
}

.added-dependencies {
  margin-bottom: 10px;
}

.dependency {
  border-bottom: 1px solid #ddd;
  padding: 0 10px;
  margin-left: 10px;
  position: relative;
}

.dependency-title {
  font-size: 15px;
}

.dependency-actions {
  position: absolute;
  right: 5px;
  top: 5px;
}
</style>
